import { DialogController } from 'aurelia-dialog';
import { autoinject } from 'aurelia-framework';
import { errorReplacer } from 'framework/error_handling/error-utils';
import { htmlify } from 'framework/script_utilities/json-htmlify';

@autoinject
export class ErrorDialog {
  details: object;

  constructor(private dialogController: DialogController) { }

  activate(options: PartialOptions) {
    Object.assign(this, new ErrorOptions(), options);
  }

  getDetails() {
    return htmlify(this.details, { replacer: errorReplacer, linkUrls: false });
  }

  ok() {
    this.dialogController.ok();
  }
}

class ErrorOptions {
  dialogTitle = 'Error';
  okTitle = 'OK';
  message: string = null;
  details: unknown = null;
  class: string = null;
  icon: string = null;
}

type PartialOptions = Partial<ErrorOptions>;
export { PartialOptions as ErrorOptions };
